import { biLogger } from './bi-logger';
import type { ReportProps } from './types';
import { createReportProps } from './events';

export const report = (props: ReportProps) =>
  biLogger.report(createReportProps(props));
